module.exports = __webpack_public_path__ + "static/img/empty-menu.2900cbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/empty-menu.svg
// module id = aWy5
// module chunks = 1